import { Tabs } from "antd";
import DatabaseBackups from "./database-backups";
import DatabaseReports from "./database-reports";
import DatabaseSchema from "./database-schema";
import DatabaseSessions from "./database-sessions";
import DatabaseSettings from "./database-settings";
import SprSotrs from "./sotrs/spr-sotrs";

const DatabaseTab = () => (
  <Tabs
    className="cabinet-inner-tabs"
    items={[
      { key: "sotrs", label: "Пользователи", children: <SprSotrs /> },
      { key: "sessions", label: "Сессии", children: <DatabaseSessions /> },
      { key: "settings", label: "Настройки", children: <DatabaseSettings /> },
      { key: "reports", label: "Отчеты", children: <DatabaseReports /> },
      { key: "schema", label: "Структура", children: <DatabaseSchema /> },
      { key: "backups", label: "Копии", children: <DatabaseBackups /> }
    ]}
  />
);

export default DatabaseTab;
